import PropTypes from "prop-types";
import React from "react";
import _ from "lodash";
import { colorFromMode } from "../../helpers";

/**
 * -Polyline-
 * Polyline component
 */
export default class Polyline extends React.Component {

    getSegmentStyle = () => {

        const {
            segmentType,
            color,
            strokeWeight,
            opacity
        } = this.props;

        if (!segmentType) {
            return {
                color,
                strokeWeight,
                opacity
            };
        }

        switch (segmentType) {

            case "road":
                return {
                    color: color || "blue",
                    strokeWeight: strokeWeight || 5,
                    opacity: opacity !== undefined
                        ? opacity
                        : 1
                };

            case "cycleway":
                return {
                    color: color || "green",
                    strokeWeight: strokeWeight || 5,
                    opacity: opacity !== undefined
                        ? opacity
                        : 1
                };

            case "offroad":
                return {
                    color: color || "brown",
                    strokeWeight: strokeWeight || 5,
                    opacity: opacity !== undefined
                        ? opacity
                        : 1
                };

            case "dismount":
                return {
                    color: color || "orange",
                    strokeWeight: strokeWeight || 5,
                    opacity: opacity !== undefined
                        ? opacity
                        : 1
                };

            default:
                return {
                    color,
                    strokeWeight,
                    opacity
                };
        }
    }

    addPolyline = () => {

        let {
            map,
            google,
            path,
            rideName,
            onRoad,
            routeNo,
            dismount,
            segmentType
        } = this.props;

        path = Array.isArray(path)
            ? path
            : google.maps.geometry.encoding.decodePath(path);

        const style = this.getSegmentStyle();

        const options = {
            clickable: true,
            map,
            strokeColor: colorFromMode(
                style.color
            ),
            strokeOpacity: style.opacity,
            strokeWeight: style.strokeWeight,
            zIndex: this.props.zIndex || 1,
            path
        };

        if (
            dismount ||
            segmentType === "dismount"
        ) {
            options.icons = [{
                icon: {
                    path: "M 0,-1 0,1",
                    scale: 2,
                    strokeOpacity: 1
                },
                offset: "0%",
                repeat: "10px"
            }];
        }

        this.polyline =
            new google.maps.Polyline(
                options
            );

        google.maps.event.addListener(
            this.polyline,
            "click",
            () => {

                if (this.props.onClick) {
                    this.props.onClick(
                        rideName
                    );
                }
            }
        );

        google.maps.event.addListener(
            this.polyline,
            "mouseover",
            (e) => {

                const lat =
                    e.latLng.lat();

                const lng =
                    e.latLng.lng();

                if (this.props.onHover) {

                    this.props.onHover(
                        rideName,
                        lat,
                        lng,
                        onRoad,
                        routeNo,
                        style.color,
                        segmentType,
                        this.props.surface
                    );
                }
            }
        );
    }

    componentDidMount() {
        this.addPolyline();
    }

    componentDidUpdate(prevProps) {

        const pathChanged =
            !_.isEqual(
                this.props.path,
                prevProps.path
            );

        const styleChanged =
            this.props.color !==
                prevProps.color ||
            this.props.strokeWeight !==
                prevProps.strokeWeight ||
            this.props.opacity !==
                prevProps.opacity ||
            this.props.segmentType !==
                prevProps.segmentType ||
            this.props.dismount !==
                prevProps.dismount;

        if (
            pathChanged ||
            styleChanged
        ) {

            if (this.polyline) {
                this.polyline.setMap(null);
            }

            this.addPolyline();
        }
    }

    componentWillUnmount() {

        if (this.polyline) {
            this.polyline.setMap(null);
        }
    }

    render() {
        return null;
    }
}

Polyline.propTypes = {
    path: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string
    ]),
    color: PropTypes.string,
    onClick: PropTypes.func,
    opacity: PropTypes.number,
    onHover: PropTypes.func,
    rideName: PropTypes.string,
    onRoad: PropTypes.bool,
    routeNo: PropTypes.string,
    strokeWeight: PropTypes.number,
    zIndex: PropTypes.number,
    dismount: PropTypes.bool,
    segmentType: PropTypes.string,
    surface: PropTypes.string
};

Polyline.defaultProps = {
    color: "random",
    strokeWeight: 5,
    opacity: 1,
    dismount: false
};


// WEBPACK FOOTER //
// ./src/components/googlemaps/Polyline.js